import React, { useEffect, useState, useCallback } from "react";
import MyNotificationsContent from "../Components/MyNotifactions/index";
import axios from "axios";

const MyNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const getNotificationsData = async () => {
      try {
        const data = await axios.get("/user/notifications");
        setNotifications(data);
        setIsLoading(false);
      } catch (e) {
        console.log("e", e);
      }
    };
    getNotificationsData();
  }, []);

  const markAsRead = useCallback(async (notificationId) => {
    try {
      await axios.post("/user/notifications/read", { notificationId });
      setNotifications(prev => 
        prev.map(n => n.id === notificationId ? { ...n, isRead: true } : n)
      );
    } catch (e) {
      console.log("Error marking notification as read:", e);
    }
  }, []);

  const markAllAsRead = useCallback(async () => {
    try {
      await axios.post("/user/notifications/read-all");
      setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
    } catch (e) {
      console.log("Error marking all notifications as read:", e);
    }
  }, []);

  const unreadCount = notifications.filter(n => !n.isRead).length;

  return (
    <MyNotificationsContent
      notifications={notifications}
      isLoading={isLoading}
      markAsRead={markAsRead}
      markAllAsRead={markAllAsRead}
      unreadCount={unreadCount}
    />
  );
};

export default MyNotifications;
